import { render, staticRenderFns } from "./AddressLocationModal.vue?vue&type=template&id=b870b658&scoped=true&"
import script from "./AddressLocationModal.vue?vue&type=script&lang=js&"
export * from "./AddressLocationModal.vue?vue&type=script&lang=js&"
import style0 from "./AddressLocationModal.vue?vue&type=style&index=0&id=b870b658&lang=sass&scoped=true&"
import style1 from "./AddressLocationModal.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b870b658",
  null
  
)

export default component.exports